// Inside the quick-add popup, the nut/chocolate toggles are links to other
// products. Instead of navigating away, reload the modal with that product.
document.addEventListener('click', (event) => {
  const link = event.target.closest(
    'quick-add-modal a.lebby-pill, quick-add-modal a.lebby-swatch'
  );
  if (!link || !link.getAttribute('href')) return;

  const modal = link.closest('quick-add-modal');
  if (!modal || typeof modal.show !== 'function') return;

  event.preventDefault();

  // QuickAddModal.show() expects the opener to carry the product URL
  // and contain a spinner element — give the link both.
  link.setAttribute('data-product-url', link.getAttribute('href'));
  if (!link.querySelector('.loading__spinner')) {
    const spinner = document.createElement('span');
    spinner.className = 'loading__spinner hidden';
    link.appendChild(spinner);
  }

  modal.show(link);
});